import * as T from '@/core/configs/types'
import get from 'lodash/get'

export const Role = {
  id: {
    type: T.Number,
    label: 'ID',
    key: 'id'
  },
  name: {
    type: T.String,
    label: 'Name',
    key: 'name'
  },
  description: {
    type: T.String,
    label: 'Description',
    key: 'description'
  },
  status: {
    type: T.Enum,
    label: 'Status',
    key: 'status',
    options: Object.values(T.StatusTypes)
  },
  createdTime: {
    type: T.Time,
    label: 'Created on',
    key: 'createdTime'
  },
  updatedTime: {
    type: T.Time,
    label: 'Updated on',
    key: 'updatedTime'
  }
}

export const RoleTableHeaders = [
  { ...Role.name, width: 200 },
  {
    ...Role.status,
    type: T.Tag,
    effect: 'plain',
    tagType: 'primary',
    width: 80
  },
  { ...Role.description, type: T.Text, width: 0 },
  { ...Role.createdTime, width: 100 }
]

export const RoleSearchForm = Object.fromEntries(
  [
    {
      ...Role.name,
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      ...Role.status,
      key: 'statusList',
      type: T.Select,
      multiple: true,
      options: [...Role.status.options],
      value: [...Role.status.options],
      validators: [T.RequiredNotEmptyListValidator],
      convertor: T.DefaultConvertor
    },
    ...T.PaginationSearchForm
  ].map(one => [one.key, one])
)

export const RoleSearchParamsWrapUp = searchForm => {
  const params = {}
  Object.keys(searchForm).forEach(key => {
    if (searchForm[key].value !== T.All) {
      params[key] = searchForm[key].value
    }
  })
  return params
}

export const RoleForm = Object.fromEntries(
  [
    {
      ...Role.name,
      type: T.TextInput,
      span: 1,
      example: '管理员',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...Role.status,
      span: 1,
      type: T.Select,
      example: 'Method',
      default: T.StatusValid,
      value: T.StatusValid,
      validators: [T.RequiredValidator]
    },
    {
      ...Role.description,
      type: T.TextInput,
      span: 1,
      example: '',
      default: '',
      value: '',
      validators: []
    }
  ].map(one => [one.key, one])
)

export const InitRoleForm = function (inputs) {
  return Object.fromEntries(
    Object.keys(RoleForm).map(key => {
      const one = {
        ...RoleForm[key],
        value: get(inputs, key, RoleForm[key].default)
      }
      return [one.key, one]
    })
  )
}
